<template>
<layout-content>
  <template #toolbar>
    <el-date-picker
      v-model="query.date"
      type="date"
      format="yyyy年MM月dd日"
      value-format="yyyy/MM/dd"
      :clearable="false"
      :editable="false"
      :picker-options="pickerOptions"
      size="small"
      style="width:170px;"
      @change="onDateChange"
    />

    <el-button
      type="warning"
      icon="el-icon-document-add"
      size="small"
      style="margin-left:0;"
      @click="onCreateReportBtnClick"
    >生成</el-button>

    <el-button
      :disabled="!hasReport"
      type="primary"
      icon="el-icon-upload"
      size="small"
      style="margin-left:0;"
      @click="onSaveReportBtnClick"
    >保存</el-button>

    <el-button
      :disabled="!hasReport"
      type="success"
      icon="el-icon-download"
      size="small"
      style="margin-left:0;"
      @click="onExportReportBtnClick"
    >导出</el-button>
  </template>

  <template #body>
    <data-wrapper class="data-editor-wrapper">
      <div v-if="rawData" class="report-data-display-wrapper">
        <div>
          <div style="font-size:14px;margin-bottom:.5em;text-align:center;">环境空气质量整体概况</div>

          <table border="1" class="report-table">
            <thead>
            <tr>
              <th>
                <div style="line-height:1;text-align:right;">因子</div>
                <div style="line-height:1;text-align:left;">统计</div>
              </th>
              <th>PM₁₀<br/>(μg/m³)</th>
              <th>PM₂.₅<br/>(μg/m³)</th>
              <th>SO₂<br/>(μg/m³)</th>
              <th>NO₂<br/>(μg/m³)</th>
              <th>O₃<br/>(μg/m³)</th>
              <th>O₃_8h<br/>(μg/m³)</th>
              <th>CO<br/>(mg/m³)</th>
              <th>AQI</th>
            </tr>
            </thead>
            <tbody>
            <tr>
              <td align="center">最小值</td>
              <td align="center">{{rawData.pm10CalculateMap.min === 'NA' ? '/' : rawData.pm10CalculateMap.min}}</td>
              <td align="center">{{rawData.pm25CalculateMap.min === 'NA' ? '/' : rawData.pm25CalculateMap.min}}</td>
              <td align="center">{{rawData.so2CalculateMap.min === 'NA' ? '/' : rawData.so2CalculateMap.min}}</td>
              <td align="center">{{rawData.no2CalculateMap.min === 'NA' ? '/' : rawData.no2CalculateMap.min}}</td>
              <td align="center">{{rawData.o3CalculateMap.min === 'NA' ? '/' : rawData.o3CalculateMap.min}}</td>
              <td align="center">{{rawData.o38hCalculateMap.min === 'NA' ? '/' : rawData.o38hCalculateMap.min}}</td>
              <td align="center">{{rawData.coCalculateMap.min === 'NA' ? '/' : rawData.coCalculateMap.min}}</td>
              <td align="center">/</td>
            </tr>
            <tr>
              <td align="center">最大值</td>
              <td align="center">{{rawData.pm10CalculateMap.max === 'NA' ? '/' : rawData.pm10CalculateMap.max}}</td>
              <td align="center">{{rawData.pm25CalculateMap.max === 'NA' ? '/' : rawData.pm25CalculateMap.max}}</td>
              <td align="center">{{rawData.so2CalculateMap.max === 'NA' ? '/' : rawData.so2CalculateMap.max}}</td>
              <td align="center">{{rawData.no2CalculateMap.max === 'NA' ? '/' : rawData.no2CalculateMap.max}}</td>
              <td align="center">{{rawData.o3CalculateMap.max === 'NA' ? '/' : rawData.o3CalculateMap.max}}</td>
              <td align="center">{{rawData.o38hCalculateMap.max === 'NA' ? '/' : rawData.o38hCalculateMap.max}}</td>
              <td align="center">{{rawData.coCalculateMap.max === 'NA' ? '/' : rawData.coCalculateMap.max}}</td>
              <td align="center">/</td>
            </tr>
            <tr>
              <td align="center">平均值</td>
              <td align="center">{{rawData.pm10CalculateMap.avg === 'NA' ? '/' : rawData.pm10CalculateMap.avg}}</td>
              <td align="center">{{rawData.pm25CalculateMap.avg === 'NA' ? '/' : rawData.pm25CalculateMap.avg}}</td>
              <td align="center">{{rawData.so2CalculateMap.avg === 'NA' ? '/' : rawData.so2CalculateMap.avg}}</td>
              <td align="center">{{rawData.no2CalculateMap.avg === 'NA' ? '/' : rawData.no2CalculateMap.avg}}</td>
              <td align="center">{{rawData.o3CalculateMap.avg === 'NA' ? '/' : rawData.o3CalculateMap.avg}}</td>
              <td align="center">{{rawData.o38hCalculateMap.avg === 'NA' ? '/' : rawData.o38hCalculateMap.avg}}</td>
              <td align="center">{{rawData.coCalculateMap.avg === 'NA' ? '/' : rawData.coCalculateMap.avg}}</td>
              <td align="center">/</td>
            </tr>
            <tr>
              <td align="center">AQI指数</td>
              <td align="center">{{Number.isFinite(aqiData['1007']) ? Math.round(aqiData['1007']) : '/'}}</td>
              <td align="center">{{Number.isFinite(aqiData['1008']) ? Math.round(aqiData['1008']) : '/'}}</td>
              <td align="center">{{Number.isFinite(aqiData['1001']) ? Math.round(aqiData['1001']) : '/'}}</td>
              <td align="center">{{Number.isFinite(aqiData['1003']) ? Math.round(aqiData['1003']) : '/'}}</td>
              <td align="center">{{Number.isFinite(aqiData['1006']) ? Math.round(aqiData['1006']) : '/'}}</td>
              <td align="center">{{Number.isFinite(aqiData['H8O3']) ? Math.round(aqiData['H8O3']) : '/'}}</td>
              <td align="center">{{Number.isFinite(aqiData['1005']) ? Math.round(aqiData['1005']) : '/'}}</td>
              <td align="center">{{Number.isFinite(aqiData.aqi) ? Math.round(aqiData.aqi) : '/'}}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <report-line-chart title="图1 AQI六参数时间序列图" :param="rawData.timeSeriesChart" />

        <div>
          <div style="font-size:14px;margin-bottom:.5em;text-align:center;">表1 {{rawData.cityName}}环境空气质量统计表</div>
          <table border="1" class="report-table">
            <thead>
            <tr>
              <th rowspan="2">时间</th>
              <th rowspan="2">点位名称</th>
              <th colspan="6">各污染物浓度</th>
              <th rowspan="2">优良天</th>
            </tr>
            <tr>
              <th>SO₂<br/>(μg/m³)</th>
              <th>NO₂<br/>(μg/m³)</th>
              <th>O₃-8H<br/>(μg/m³)</th>
              <th>CO<br/>(mg/m³)</th>
              <th>PM₁₀<br/>(μg/m³)</th>
              <th>PM₂.₅<br/>(μg/m³)</th>
            </tr>
            </thead>
            <tbody>
            <tr
              v-for="(data, index) in sitePollutantStatistical"
              :key="index"
            >
              <td
                v-if="index === 0"
                :rowspan="sitePollutantStatistical.length"
                align="center"
              >{{formatDate}}</td>
              <td align="center">{{data.name}}</td>
              <td align="center">{{data.SO2 === 'NA' ? '/' : data.SO2}}</td>
              <td align="center">{{data.NO2 === 'NA' ? '/' : data.NO2}}</td>
              <td align="center">{{data.O38H === 'NA' ? '/' : data.O38H}}</td>
              <td align="center">{{data.CO === 'NA' ? '/' : data.CO}}</td>
              <td align="center">{{data.PM10 === 'NA' ? '/' : data.PM10}}</td>
              <td align="center">{{data.PM25 === 'NA' ? '/' : data.PM25}}</td>
              <td align="center">{{data.godDay === 'NA' ? '/' : data.godDay}}</td>
            </tr>
            <tr>
              <td align="center">{{year}}年累计</td>
              <td align="center">站点综合</td>
              <td align="center">{{Number.isFinite(rawData.yearAvgMap.SO2) ? rawData.yearAvgMap.SO2.toFixed(2) : '/'}}</td>
              <td align="center">{{Number.isFinite(rawData.yearAvgMap.NO2) ? rawData.yearAvgMap.NO2.toFixed(2) : '/'}}</td>
              <td align="center">{{Number.isFinite(rawData.yearAvgMap.H8O3) ? rawData.yearAvgMap.H8O3.toFixed(2) : '/'}}</td>
              <td align="center">{{Number.isFinite(rawData.yearAvgMap.CO) ? rawData.yearAvgMap.CO.toFixed(2) : '/'}}</td>
              <td align="center">{{Number.isFinite(rawData.yearAvgMap.PM10) ? rawData.yearAvgMap.PM10.toFixed(2) : '/'}}</td>
              <td align="center">{{Number.isFinite(rawData.yearAvgMap['PM2.5']) ? rawData.yearAvgMap['PM2.5'].toFixed(2) : '/'}}</td>
              <td align="center">{{Number.isFinite(rawData.goodDay) ? rawData.goodDay : '/'}}</td>
            </tr>
            <tr>
              <td align="center">{{year - 1}}同期累计</td>
              <td align="center">站点综合</td>
              <td align="center">{{Number.isFinite(rawData.lastYearAvgMap.SO2) ? rawData.lastYearAvgMap.SO2.toFixed(2) : '/'}}</td>
              <td align="center">{{Number.isFinite(rawData.lastYearAvgMap.NO2) ? rawData.lastYearAvgMap.NO2.toFixed(2) : '/'}}</td>
              <td align="center">{{Number.isFinite(rawData.lastYearAvgMap.H8O3) ? rawData.lastYearAvgMap.H8O3.toFixed(2) : '/'}}</td>
              <td align="center">{{Number.isFinite(rawData.lastYearAvgMap.CO) ? rawData.lastYearAvgMap.CO.toFixed(2) : '/'}}</td>
              <td align="center">{{Number.isFinite(rawData.lastYearAvgMap.PM10) ? rawData.lastYearAvgMap.PM10.toFixed(2) : '/'}}</td>
              <td align="center">{{Number.isFinite(rawData.lastYearAvgMap['PM2.5']) ? rawData.lastYearAvgMap['PM2.5'].toFixed(2) : '/'}}</td>
              <td align="center">{{Number.isFinite(rawData.goodDayLast) ? rawData.goodDayLast : '/'}}</td>
            </tr>
            <tr>
              <td align="center" colspan="2">{{year}}同比变化(%)</td>
              <td align="center">{{rawData.yoyMap.so2Yoy}}</td>
              <td align="center">{{rawData.yoyMap.no2Yoy}}</td>
              <td align="center">{{rawData.yoyMap.h8o3Yoy}}</td>
              <td align="center">{{rawData.yoyMap.coYoy}}</td>
              <td align="center">{{rawData.yoyMap.pm10Yoy}}</td>
              <td align="center">{{rawData.yoyMap.pm25Yoy}}</td>
              <td align="center">{{rawData.yoyMap.goodDayYoy}}</td>
            </tr>
            </tbody>
          </table>
        </div>

        <report-pie-chart v-if="vocsAvgList.length > 0" :title="`图2 ${formatDate}光化学组分监测结果`" :data="vocsAvgList" />
      </div>

      <div class="html-content-editor-wrapper">
        <div class="html-content-editor-inner">
          <vue-ueditor-wrap v-model="htmlContent" :config="editorConfig" class="html-content-editor" />
        </div>
      </div>
    </data-wrapper>
  </template>
</layout-content>
</template>

<script>
import BaseWordEditor from '../BaseWordEditor'
import LayoutContent from '../../../../components/Layout/Content'
import DataWrapper from '../../../../components/Data/DataWrapper'
import ReportLineChart from '../../../../components/ReportChart/ReportLineChart'
import ReportPieChart from '../../../../components/ReportChart/ReportPieChart'

export default {
  name: 'DayReport',
  routeInfo: {
    label: '日报',
    icon: 'fa fa-users'
  },
  extends: BaseWordEditor,
  components: {ReportPieChart, ReportLineChart, DataWrapper, LayoutContent},
  computed: {
    apiKey: () => 'Report',
    pickerOptions: () => ({
      disabledDate: time => {
        const today = new Date()
        today.setHours(0, 0, 0, 0)
        return time >= today
      }
    }),
    aqiData () {
      const {aqiList} = this.rawData
      return aqiList.length > 0 ? aqiList[0].pollutantData.reduce((map, pollutantData) => {
        map[pollutantData.rootFactorId === 'H8O3' ? 'H8O3' : pollutantData.factorId] = pollutantData.iaqi
        return map
      }, {
        aqi: aqiList[0].aqi
      }) : {}
    },
    sitePollutantStatistical () {
      const {rawData} = this
      const list = []

      if (rawData) {
        const {siteDataMap} = rawData

        if (siteDataMap) {
          const {siteNameMap} = rawData

          for (let key in siteNameMap) {
            let siteData = siteDataMap[key]

            if (siteData) {
              const {SO2, NO2, H8O3, CO, PM10} = siteData
              const PM25 = siteData['PM2.5']

              list.push({
                name: siteNameMap[key],
                SO2: SO2 ? Number((SO2.reduce((sum, value) => sum + value, 0) / SO2.length).toFixed(2)) : '/',
                NO2: NO2 ? Number((NO2.reduce((sum, value) => sum + value, 0) / NO2.length).toFixed(2)) : '/',
                O38H: H8O3 ? Number((H8O3.reduce((sum, value) => sum + value, 0) / H8O3.length).toFixed(2)) : '/',
                CO: CO ? Number((CO.reduce((sum, value) => sum + value, 0) / CO.length).toFixed(2)) : '/',
                PM10: PM10 ? Number((PM10.reduce((sum, value) => sum + value, 0) / PM10.length).toFixed(2)) : '/',
                PM25: PM25 ? Number((PM25.reduce((sum, value) => sum + value, 0) / PM25.length).toFixed(2)) : '/',
                godDay: '/'
              })
            }
          }
        }

        list.push({
          name: '站点综合',
          SO2: rawData.so2CalculateMap.avg,
          NO2: rawData.no2CalculateMap.avg,
          O38H: rawData.o38hCalculateMap.avg,
          CO: rawData.coCalculateMap.avg,
          PM10: rawData.pm10CalculateMap.avg,
          PM25: rawData.pm25CalculateMap.avg,
          godDay: '/'
        })
      }

      return list
    },
    formatDate () {
      return this.query.date.replace('/', '年').replace('/', '月') + '日'
    },
    year () {
      return Number(this.query.date.substr(0, 4))
    },
    vocsAvgList () {
      return this.rawData.vocsAvgList.map(data => ({
        value: data.value,
        name: data.groupName
      }))
    }
  },
  methods: {
    getDate () {
      const date = new Date()
      date.setDate(date.getDate() - 1)
      return date.format('YYYY/MM/DD')
    }
  }
}
</script>

<style lang="scss" scoped>
.report-table {
  font-size: 14px;
  min-width: 100%;
  border-color: #ebeef5;
  white-space: nowrap;

  th,
  td {
    padding: 3px 5px;
  }

  th {
    background-color: #f9f9f9;
  }

  tr {
    &:nth-child(2n) {
      /*background-color: #fafafa;*/
    }

    &:hover {
      background-color: #f5f7fa !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/06Data-Management/03Report/00DayReport/index.vue